import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'
import { ParticleSystem, type BurstOptions } from './particles'

export interface ParticleHandle {
  burst(nx: number, ny: number, opts?: BurstOptions): void
  confetti(): void
  clear(): void
}

export const ParticleCanvas = forwardRef<ParticleHandle>(function ParticleCanvas(_, ref) {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const systemRef = useRef<ParticleSystem | null>(null)

  useEffect(() => {
    const canvas = canvasRef.current!
    const system = new ParticleSystem(canvas)
    systemRef.current = system
    const ro = new ResizeObserver(() => system.resize())
    ro.observe(canvas)
    return () => ro.disconnect()
  }, [])

  useImperativeHandle(ref, () => ({
    burst: (x, y, opts) => systemRef.current?.burst(x, y, opts),
    confetti: () => systemRef.current?.confetti(),
    clear: () => systemRef.current?.clear(),
  }))

  return <canvas ref={canvasRef} className="fx-canvas" aria-hidden="true" />
})
